import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { CompanyPriceSurveyValidationSchema } from '@/features/privateCompanies/schemas/priceSurvey/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseCreateCompanyPriceSurvey {
  companyId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: AxiosError) => void
}

export const useCreateCompanyPriceSurvey = ({ companyId, onSuccess, onError }: UseCreateCompanyPriceSurvey) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createCompanyPriceSurvey'],
    mutationFn: async (form: CompanyPriceSurveyValidationSchema) => {
      const price_survey = {
        company_id: companyId,
        survey_conducted_at: form.survey_conducted_at,
        geo_geoables_attributes: form.geo_geoables_attributes?.map((geo) => ({
          geo_id: geo.value,
          geo_type: 'Geo::City',
        })),
        price_survey_products_attributes: form.price_survey_products_attributes?.map((product) => ({
          product_id: product.product_id,
          price: unFormatCurrency(product.price),
        })),
        evidences_attachments_attributes: form.evidences_attachments_attributes?.map((attachment) => ({
          blob_id: attachment.id,
        })),
      }

      return privateAxios.post('/client/price_surveys', { price_survey })
    },
    onSuccess,
    onError,
  })
}
